import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const MapContext = createContext(null);
const MapProvider = (props) => {
    const { map, children } = props;
    return (_jsx(MapContext.Provider, { value: map, children: children }));
};
export default MapProvider;
